import React from 'react';
import { Checkbox, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import UsergroupPanelTabs from '../components/UsergroupPanelTabs';
import UserGroupDescription from './UserGroupDescription';
import UserGroupName from './UserGroupName';
import UserGroupPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/UserGroupPanelContainer';

const UserGroupPanelFull = ({
  bpmn,
  canCreate,
  canRead,
  category,
  code,
  description,
  fetchGroup,
  gridColumns = 2,
  isDirty,
  isDuplicate,
  isEditing,
  isNew,
  name,
  newGroup,
  onChange,
  readErrors,
  readStatus,
  saveErrors,
  updateProperties,
  url,
}) => {
  const intl = useIntl();
  return (
    <UserGroupPanelContainer
      canCreate={canCreate}
      canRead={canRead}
      category={category}
      code={code}
      description={description}
      fetchGroup={fetchGroup}
      isDirty={isDirty}
      isDuplicate={isDuplicate}
      isNew={isNew}
      name={name}
      newGroup={newGroup}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      url={url}
    >
      <div className="aridhia-usergroup-panel-full">
        <EntitiesErrorMessages
          category={category}
          code={code}
          entity="usergroup"
          errors={saveErrors}
          onDismiss={(errors) => updateProperties(category, code, { saveErrors: errors })}
        />
        <Grid columns={gridColumns}>
          <Grid.Row columns="equal">
            <Grid.Column>
              <UserGroupName code={code} category={category} />
            </Grid.Column>
            <Grid.Column>
              <div className="float-r">
                {isEditing && (
                  <Checkbox
                    checked={bpmn}
                    toggle
                    label={intl.formatMessage({ id: 'usergroup.bpmn' })}
                    onClick={() => updateProperties(category, code, { bpmn: !bpmn })}
                  />
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal">
            <Grid.Column>
              <UserGroupDescription code={code} category={category} />
            </Grid.Column>
            <Grid.Column />
          </Grid.Row>
          {(!isEditing || isDuplicate) && (
            <Grid.Row columns="1">
              <Grid.Column>
                <UsergroupPanelTabs category={category} code={code} isDuplicate={isDuplicate} />
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </div>
    </UserGroupPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupPanelFull);
